// CarouselComponent.tsx

import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import Text from '../text/Text'
import './CarouselStyles.css'
import LogoV2 from './../../assets/icons/logo-amipossv2.png'

interface ICarouselComponentProps {
    data: { image: string; title: string }[]
}
const renderIndicator = (
    onClickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
    isSelected: boolean
) => {
    const indicatorClassName = isSelected
        ? 'custom-indicator indicator-active '
        : 'custom-indicator'

    return (
        <div
            className={indicatorClassName}
            onClick={onClickHandler}
            role="button"
            tabIndex={0}
        />
    )
}

const CarouselComponent: React.FC<ICarouselComponentProps> = ({ data }) => {
    return (
        <div className="carousel-container">
            <div className="amiposs-logo-container">
                <img src={LogoV2} className="amiposs-logo" width={200} />
            </div>

            <Carousel
                className="carousel-com"
                autoPlay
                infiniteLoop
                showArrows={false}
                showThumbs={false}
                showStatus={false}
                renderIndicator={renderIndicator}
            >
                {data.map((item, index) => (
                    <div key={index}>
                        <img
                            className="slide-image"
                            src={item.image}
                            alt={item.title}
                        />
                        <div className="carousel-title">
                            <Text
                                label={item.title}
                                fontSize={25}
                                fontWeight={600}
                                color={'#0086D6'}
                            />
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    )
}

export default CarouselComponent
